import { useLocation } from 'react-router-dom';
import styles from './PageTransition.module.css';

interface PageTransitionProps {
  children: React.ReactNode;
}

/**
 * Wraps page content with a fade-in/slide-up animation.
 * Re-triggers on every pathname change via React's key-based remount.
 */
export const PageTransition = ({ children }: PageTransitionProps) => {
  const { pathname } = useLocation();

  return (
    <div key={pathname} className={styles.pageTransition}>
      {children}
    </div>
  );
};
